import React from 'react';
import './Contact.css';

const Contact = () => {
  const contacts = [
    {
      name: 'Fuad Poroshtica',
      email: 'Fuad@poroshtica.com',
      color: '#FF1493' // Deep pink
    },
    {
      name: 'Donika Poroshtica',
      email: 'Donika@poroshtica.com',
      color: '#90EE90' // Light green
    },
    {
      name: 'Selim Poroshtica',
      email: 'Selim@poroshtica.com',
      color: '#FF4500' // Red orange
    },
    {
      name: 'Fexhrie Poroshtica',
      email: 'Fexhrie@poroshtica.com',
      color: '#4169E1' // Royal blue
    }
  ];

  return (
    <div className="contact">
      <div className="contact-container">
        <h1 className="contact-title">Contact us</h1>
        <div className="contact-grid">
          {contacts.map((contact, index) => (
            <div key={index} className="contact-card">
              <div 
                className="contact-avatar"
                style={{ backgroundColor: contact.color }}
              >
                <span className="avatar-initial">
                  {contact.name.charAt(0)}
                </span>
              </div>
              <div 
                className="contact-name"
                style={{ backgroundColor: contact.color }}
              >
                {contact.name}
              </div>
              <a 
                href={`mailto:${contact.email}`}
                className="contact-email"
              >
                {contact.email}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Contact;